// 等待DOM元素出现的函数
function waitForElement(selector, callback, timeout = 10000) {
    const element = document.querySelector(selector);
    if (element) {
        callback(element);
        return;
    }
    const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector(selector);
        if (element) {
            obs.disconnect();
            callback(element);
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // 设置超时，避免无限等待
    setTimeout(() => {
        observer.disconnect();
    }, timeout);
}
// 在DOM加载完成后开始监听
document.addEventListener('DOMContentLoaded', function() {
    // 确保jQuery已加载
    if (typeof jQuery === 'undefined') {
        return;
    }
    initCompareStyles();
    initArtisanFitGuide();
});
function initCompareStyles() {
    // 等待bcpo元素出现
    waitForElement('#bcpo', function(bcpoElement) {
        // 使用jQuery包装元素
        var $bcpoContainer = $(bcpoElement);
        // 查找bcpo-label中bcpo-title为"Style:"的元素
        var $styleLabel = $bcpoContainer.find('.bcpo-label').filter(function() {
            return $(this).find('.bcpo-title').text().trim() === 'Style:';
        });
        if ($styleLabel.length > 0) {
            // 检查是否已经添加了按钮，避免重复添加
            if ($styleLabel.find('.new_compare_styles_popup_btn').length === 0) {
                // 创建按钮
                var $compareButton = $('<div class="new_compare_styles_popup_btn">Compare Styles</div>');
                // 将按钮插入到label中
                $styleLabel.append($compareButton);
                // 为按钮添加点击事件
                $compareButton.on('click', function() {
                    // 创建蒙版层
                    if ($('#newVariantsPopupMask').length === 0) {
                        var $overlayMask = $('<div id="newVariantsPopupMask" class="new_product_variants_popup_mask"></div>');
                        $styleLabel.append($overlayMask);
                        // 为蒙版添加点击事件
                        $overlayMask.on('click', function() {
                            hideCompareStylesPopup();
                        });
                    }
                    // 显示蒙版和弹窗
                    $('#newVariantsPopupMask').fadeIn();
                    $('#CompareStylesPopup').fadeIn();
                });
            }
        }
    });
}
function initArtisanFitGuide() {
    // 等待bcpo元素出现
    waitForElement('#bcpo', function(bcpoElement) {
        // 使用jQuery包装元素
        var $bcpoContainer = $(bcpoElement);
        // 查找bcpo-label中bcpo-title为"Style:"的元素
        var $styleLabel = $bcpoContainer.find('.bcpo-label').filter(function() {
            return $(this).find('.bcpo-title').text().trim() === 'Size:';
        });
        if ($styleLabel.length > 0) {
            // 检查是否已经添加了按钮，避免重复添加
            if ($styleLabel.find('.new_artisan_fit_popup_btn').length === 0) {
                // 创建按钮
                var $compareButton = $('<div class="new_artisan_fit_popup_btn">Size Guide</div>');
                // 将按钮插入到label中
                $styleLabel.append($compareButton);
                // 为按钮添加点击事件
                $compareButton.on('click', function() {
                    // 创建蒙版层
                    if ($('#newVariantsPopupMask2').length === 0) {
                        var $overlayMask = $('<div id="newVariantsPopupMask2" class="new_product_variants_popup_mask"></div>');
                        $styleLabel.append($overlayMask);
                        // 为蒙版添加点击事件
                        $overlayMask.on('click', function() {
                            hideCompareStylesPopup2();
                        });
                    }
                    // 显示蒙版和弹窗
                    $('#newVariantsPopupMask2').fadeIn();
                    $('#ArtisanFitGuidePopup').fadeIn();
                });
            }
        }
    });
}
// 隐藏Compare Styles弹窗和蒙版
function hideCompareStylesPopup() {
    $('#newVariantsPopupMask').fadeOut(function() {
        $(this).remove();
    });
    $('#CompareStylesPopup').fadeOut();
}
function hideCompareStylesPopup2() {
    $('#newVariantsPopupMask2').fadeOut(function() {
        $(this).remove();
    });
    $('#ArtisanFitGuidePopup').fadeOut();
}
// 为弹窗关闭按钮添加事件
$(document).on('click', '#closePopup', function() {
    hideCompareStylesPopup();
});
$(document).on('click', '#closePopup2', function() {
    hideCompareStylesPopup2();
});

// 将custom.compare_styles_content元子段中的图片URL转为img标签
function convertImageUrlsToImgTags() {
  const contentElements = document.querySelectorAll('.new_product_variants_popup_content');
  contentElements.forEach(element => {
    const html = element.innerHTML;
    const urlRegex = /https?:\/\/[^\s]+\.(?:png|jpg|jpeg|gif|webp|svg)(?:\?[^\s]*)?/g;
    const processedHtml = html.replace(urlRegex, (match) => {
      return `<img src="${match}" alt="产品图片" />`;
    });
    element.innerHTML = processedHtml;
  });
}
document.addEventListener('DOMContentLoaded', convertImageUrlsToImgTags);


(function () {
    const container = document.querySelector('.product_media_swiper_container');
    if (!container) return;
    const popup = document.querySelector('.new_product_media_page_container').querySelector('.product_media_swiper_detail_popup');
    const popupImg = popup ? popup.querySelector('.product_media_swiper_detail_popup__img') : null;
    const popupClose = popup ? popup.querySelector('.product_media_swiper_detail_popup__close') : null;
    function openPopup(detailSrc, detailAlt) {
        if (!popup || !popupImg || !detailSrc) return;
        popupImg.src = detailSrc;
        popupImg.alt = detailAlt || '';
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('product_media_swiper_popup_open');
    }
    function closePopup() {
        if (!popup || !popupImg) return;
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        popupImg.src = '';
        document.documentElement.classList.remove('product_media_swiper_popup_open');
    }
    container.addEventListener('click', (e) => {
        const trigger = e.target.closest('.product_media_swiper_popupShow');
        if (trigger && container.contains(trigger)) {
            const img = trigger.querySelector('img');
            const detailSrc = trigger.getAttribute('data-detail-src') || (img && (img.currentSrc || img.src)) || '';
            const detailAlt = trigger.getAttribute('data-detail-alt') || (img && img.alt) || '';
            openPopup(detailSrc, detailAlt);
            return;
        }
        if (!popup) return;
        if (popup.classList.contains('is-open')) {
            const dialog = popup.querySelector('.product_media_swiper_detail_popup__dialog');
            const clickedInsideDialog = dialog && dialog.contains(e.target);
            if (!clickedInsideDialog) closePopup();
        }
    });
    if (popupClose) popupClose.addEventListener('click', closePopup);
})();